/* eslint-disable @nice-cxone/ccf/required-tsdoc */
import './ccf-ga-login.module.scss';
import { Button } from '@mui/material';
import { AuthSettings } from '@nice-ccf/common-sdk';
import { gaLoginActions } from './gaLoginSlice';
import { useDispatch } from 'react-redux';

export interface CcfGaLoginProps {
  consumerAppName: string;
  authSettings: AuthSettings;
  authMode: string;
  codeChallengeMethod: string;
  loginConsumerCallback(message: string): void;
}

export function CcfGaLogin(props: CcfGaLoginProps) {
  const dispatch = useDispatch();
  const loginClickHandler = () => {
    dispatch(gaLoginActions.login(props));
  };
  return (
    <div>
      <Button
        onClick={() => loginClickHandler()}
        color="primary"
        variant="contained"
        size="small"
      >
        Log In
      </Button>
    </div>
  );
}

export default CcfGaLogin;
